@if (isVisible) {
  <footer data-zid="footer">
    <div class="container pb-4 pt-4">
      <div class="row">
        <div class="col-md-6 text-md-left">
          <div class="mb-2" (click)="cleverPushFeatureClick()">
            <svg class="icon icon-footer-logo">
              <use xlink:href="/assets/img/svgs/svgset.svg#zero-logo-gray" />
            </svg>
          </div>
          <div class="zero-text p-base-lig">
            {{ 'footer.copyright' | transloco }}
          </div>
          <div class="mt-4 zero-text p-base-bold">{{ 'footer.app' | transloco }}</div>
          <div class="row mt-2">
            <div class="col-12 col-lg-4">
              <a [href]="URL_APPSTORE_APPLE" target="_blank" rel="noopener noreferrer nofollow">
                <svg class="app-icon small zero-text default">
                  <use xlink:href="/assets/img/svgs/svgset.svg#ios-app" />
                </svg>
              </a>
            </div>
            <div class="col-12 col-lg-4 mt-2 mt-lg-0">
              <a [href]="URL_APPSTORE_GOOGLE" target="_blank" rel="noopener noreferrer nofollow">
                <svg class="app-icon small zero-text default">
                  <use xlink:href="/assets/img/svgs/svgset.svg#google-app" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-md-3 text-left mt-4 mt-md-0">
          <h4 class="text-transform-unset">{{ 'footer.legal.header' | transloco }}</h4>
          <ul class="list footer">
            <li>
              <a class="zero-text p-base-lig default" [href]="landingPage + '/impressum'" target="_blank" rel="noopener noreferrer">
                {{ 'footer.legal.imprint' | transloco }}
              </a>
            </li>
            <li>
              <a class="zero-text p-base-lig default" [href]="landingPage + '/datenschutz'" target="_blank" rel="noopener noreferrer">
                {{ 'footer.legal.privacy' | transloco }}
              </a>
            </li>
            <li>
              <a class="zero-text p-base-lig default" [href]="landingPage + '/disclaimer'" target="_blank" rel="noopener noreferrer">
                {{ 'footer.legal.disclaimer' | transloco }}
              </a>
            </li>
            <li>
              <a class="zero-text p-base-lig default" [href]="landingPage + '/formulare'" target="_blank" rel="noopener noreferrer">
                {{ 'footer.legal.forms' | transloco }}
              </a>
            </li>
            <li>
              <a
                class="zero-text p-base-lig default"
                href="https://www.finanzen.net/zero/wp-content/uploads/2021/05/finanzennetzero_Preis-Leistungsverzeichnis.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ 'footer.legal.list-of-prices' | transloco }}
              </a>
            </li>
            <li>
              <a class="zero-text p-base-lig default cursor-pointer" (click)="sourcePointService.displayPrivacyManagerModal()">
                {{ 'footer.legal.privacy-settings' | transloco }}
              </a>
            </li>
            <li>
              <a class="zero-text p-base-lig default cursor-pointer" (click)="sourcePointService.revokeTracking()">
                {{ 'footer.legal.avoid-tracking' | transloco }}
              </a>
            </li>
          </ul>
        </div>
        <div class="col-12 col-sm-6 col-md-3 text-left mt-4 mt-md-0">
          <h4 class="text-transform-unset">{{ 'footer.info.header' | transloco }}</h4>
          <ul class="list footer">
            <li>
              <a class="zero-text p-base-lig default" href="https://support.finanzen-zero.net" target="_blank" rel="noopener noreferrer">
                {{ 'footer.info.faq' | transloco }}
              </a>
            </li>
            <li>
              <a class="zero-text p-base-lig default" [href]="landingPage + '/fair-use-policy'" target="_blank" rel="noopener noreferrer">
                {{ 'footer.info.fair-use-policy' | transloco }}
              </a>
            </li>
            <li>
              @if (authStateFacade.loggedIn$ | async) {
                <a class="zero-text p-base-lig default" [routerLink]="commonRoutes.postlogin.tickets">
                  {{ 'footer.info.contact' | transloco }}
                </a>
              } @else {
                <a class="zero-text p-base-lig default" [href]="landingPage + '/kontakt'" target="_blank" rel="noopener noreferrer">
                  {{ 'footer.info.contact' | transloco }}
                </a>
              }
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
}
